const compressFromBase64 = (text: string) => {
	return atob(text);
};

export default compressFromBase64;
